import * as yup from "yup";

import { Shape } from "@/core/yup";

import { GeneralInformationFormTypes } from "./GeneralInformationForm";

export const formSchema = () =>
    yup.object<{}, Shape<GeneralInformationFormTypes>>({
        personalTitle: yup.string().required(),
        lastName: yup.string().required(),
        firstName: yup.string().required(),
        gender: yup.string().required(),
        maritalStatus: yup.string().required(),
        birthdate: yup.date().birthdate().nullable(),
        language: yup.string().required(),
    });
